<template>
  <UIPersonInfo
    :head="userHead"
    :nick="userNick"
    :tips="tips"
    :title="title"
    @clickBack="clickBack"
    @clickConfirm="clickConfirm"
  >
    <template #default>
      <UiTipMatchImgSelector
        :need-crop="true"
        :center-box="true"
        style="width: 2.64rem; height: 0.64rem; position: absolute;"
        :clz-name="'profile-image-selector'"
        @startUpload="startUpload"
        @uploadSuccess="onUploadSuccess"
        @uploadFail="onUploadFailed"
      />
    </template>
  </UIPersonInfo>
</template>

<script>
import UIPersonInfo from 'src/local-component/ui/tip-match/tip-match-person-info/index-web';
import UiTipMatchImgSelector from 'src/local-component/module/tip-match/tip-match-upload-img';

export default {
  name: 'MatchPersonInfoWeb',
  components: {
    UIPersonInfo,
    UiTipMatchImgSelector,
  },
  props: {
    head: {
      type: String,
      desc: '头像',
      default: '',
    },
    nick: {
      type: String,
      desc: '昵称',
      default: '',
    },
    tips: {
      type: String,
      desc: '提示文案',
      default: '在生成分享图时展示个人信息',
    },
    title: {
      type: String,
      desc: '标题',
      default: '',
    },
  },
  data() {
    return {
      userHead: '',
      userNick: '',
    };
  },
  watch: {
    head: {
      handler(newV) {
        this.userHead = newV;
      },
      immediate: true,
    },
    nick: {
      handler(newV) {
        this.userNick = newV;
      },
      immediate: true,
    },
  },
  methods: {
    clickBack(...args) {
      this.$emit('clickBack', ...args);
    },
    clickConfirm({ head, nick }) {
      this.$emit('clickConfirm', {
        head,
        nick,
      });
    },
    startUpload() {
      this.showLoading('上传中');
    },
    onUploadSuccess(data) {
      this.dismissLoading();
      this.userHead = data.url;
    },
    onUploadFailed() {
      this.dismissLoading();
      this.showToast('图片上传失败');
    },
  },
};
</script>

<style scoped>

.profile-image-selector {
  width: 0.64rem;
  height: 0.64rem;
  position: absolute;
}

</style>
